export enum TruckType {
    Unknown = 0,
    Trailer = 1,
    IsoContainer = 2,
    Truck = 3
}